import action from "./action"
import event from "./event"

export default {
    action, event
}